import { render } from "./TsorRowSingle.vue?vue&type=template&id=995100d8"
import script from "./TsorRowSingle.vue?vue&type=script&lang=js"
export * from "./TsorRowSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__